var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkout-step',{attrs:{"step-num":"5","step":_vm.step,"stepName":"Confirmation"},on:{"continue":function($event){_vm.$emit('valid')}}},[_c('div',{attrs:{"slot":"active"},slot:"active"},[_c('p',[_vm._v("Are all your order details correct?")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6beaaae9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout-steps/CheckoutStep5.vue
// module id = null
// module chunks = 